import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import CustomBtn from "./ButtonTemplate";

interface EditBtnProps {
  action: () => void;
  tip?: string;
}

function EditBtn({ action, tip = "Edit" }: EditBtnProps) {
  return (
    <CustomBtn action={action} type="success" icon={<EditIcon />} tip={tip} />
  );
}

export default EditBtn;
